<template>
    <div class="filter_plate">
        <!-- <div class="filter_extra_block">
            <div class="compare_box for_desktop">
                <div class="advance_filter" @click="advancedFilter">
                    <label class="mb-0 mr-2">Advanced Filters</label>
                    <SvgHeaderSvg v-if="togglers.advancedFilter" :type="'minus'" />
                    <SvgHeaderSvg v-else :type="'plus'" />
                </div>
            </div>
            <div class="extra_filters">
                <client-only>
                    <div v-if="filterCount != 0" class="reset_filter for_desktop" @click="resetFilters">
                        <label class="mb-0">Remove Filters ({{ filterCount }})</label>
                        <SvgHeaderSvg :type="'close'" />
                    </div>
                </client-only>
            </div>
        </div> -->
        <div class="row filter_flate">
            <div class="col-md-6 ps-0 for_desktop" >
                <div class="filter_left ms-2">
                    <button @click="$emit('toggleTable', 'result')" :class="[table === 'result' ? 'active' : '']" class="for_desktop">
                        Results {{resultCount && `(${resultCount})`}}
                    </button>
                    <button @click="$emit('toggleTable', 'compare')" :class="[table === 'compare' ? 'active' : '']" class="for_desktop">
                        Compare ({{ compareCount }})
                    </button>
                </div>
            </div>
            <div class="col-md-6 col-12 text-right pe-0">
                <div class="filter_right">
                    <div class="diamond_view d-flex align-content-center" v-if="moduleSubType != 'earring' && getListView">
                        <div @click="onChangeCheckbox(getListView[0])" :class="{ 'active': getListView[0].active === 0 }" class="me-2">
                            <SvgHeaderSvg :type="'grid'" />
                        </div>
                        <div @click="onChangeCheckbox(getListView[0])" :class="{ 'active': getListView[0].active === 1 }" class="me-2">
                            <SvgHeaderSvg :type="'oldlist'" />
                        </div>
                    </div>
                    <div class="select_block select_block_border">
                        <span class="me-1">Sort by :  {{ currentSort }} </span>
                        <select class="custom-select" @change="onChangeSelect($event, 'sort')">
                            <optgroup v-for="option in getSortFilterOptions" :key="option.label" :label="option.label">
                                <option v-for="opt in option.options" :key="opt.value" :selected="opt.active" :value="opt.value"  :class="{'active': opt.active}">{{ opt.label }}</option>
                            </optgroup>
                        </select>
                    </div>
                    
                    
                </div>
            </div>
        </div>
        <!-- <client-only>
            <div class="reset_btn for_mobile">
                <div v-if="filterCount != 0" class="reset_filter" @click="resetFilters">
                    <label class="mb-0">Remove Filters ({{ filterCount }})</label>
                    <SvgHeaderSvg :type="'close'" />
                </div>
            </div>
        </client-only> -->
    </div>
</template>

<script setup>
    import { ref, computed, inject, onMounted } from 'vue'
    import {cyolistStore}  from '@/stores/cyolist/cyolist';

    const props = defineProps(['togglers', 'table'])
    const moduleSubType = inject('moduleSubType')
    const moduleType = inject('moduleType')

    const store = cyolistStore();

    const viewActive = ref(true)

    const resultCount = computed(() => store.getSettingListingResultCount())
    const compareCount = computed(() => store.getSettingListingCompareListCount())

    const getSortFilter = computed(() => store.getSettingFilter(moduleSubType, 'sort'))
    const getListviewFilter = computed(() => store.getSettingFilter(moduleSubType, 'listview'))

    const getListView = computed(() => store.getSettingFilterOptions(moduleSubType, 'listview'))
    const getSortFilterOptions = computed(() => store.getSettingFilterOptions(moduleSubType, 'sort'))

    const getQuickShipFilter = computed(() => store.getSettingFilter(moduleSubType, 'quickship'))
    const getQuickShipFilterOptions = computed(() => store.getSettingFilterOptions(moduleSubType, 'quickship'))

    const filterCount = computed(() => {
        const payload = store.getRequestPayload()
        if (!payload) return 0

        const activeFilters = []
        for (const fil in payload) {
            const filter = fil.replace('From', '').replace('To', '')
            if (!activeFilters.includes(filter) && !['page'].includes(filter)) {
            activeFilters.push(filter)
            }
        }
        return activeFilters.length
    })

    const currentSort = computed(() => {
        let label = ''
        if (getSortFilterOptions.value) {
            getSortFilterOptions.value.forEach(opt => {
            if (opt.options) {
                opt.options.forEach(act => {
                if (act.active) {
                    label = opt.label
                }
                })
            }
            })
        }
        return label
    })

    const advancedFilter = () => {
        props.togglers.advancedFilter = !props.togglers.advancedFilter
    }

    const checkFilter = (name) => {
        return false
        return store.getters.getSettingFilter(moduleSubType, name) ?? null
    }

    const onChangeSelect = (event, name) => {
        store.toggleSettingFilter({ reset: false, type: moduleSubType, filter: getSortFilter.value, event })
    }

    const onChangeCheckbox = (option) => {
        store.toggleSettingFilter({ reset: false, type: moduleSubType, filter: getListviewFilter.value, option, name: 'listview' })
    }

    const resetFilters = () => {
        window.location = window.location.pathname
    }
</script>



<style scoped>
.diamond_view {
    /* margin-left: 20px; */
    cursor: pointer;
}
.filter_flate {
    background: #f5f5f5;
    margin: 30px 0;
    display: flex;
    align-items: center;
    padding: 12px 0;
    border-radius: 8px;
}
.filter_flate button{
    border: 0;
    background: #fff;
    font-size: 14px;
    color: var(--green);
    min-width: 130px;
    line-height: normal;
    padding: 1.4% 1%;
    margin-right: 12px;
    border-radius: 8px;
    height: 44px;
}

.filter_flate button.active{
    color: var(--green) !important;
    font-weight: 600;
    /* color: #fff; */
}
.select_block_border select {
    border: 0;
    min-width: 120px;
}

.filter_left {
    display: flex;
    align-items: center;
}
.filter_right{
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 8px;
}
optgroup {
    font-weight: 400;
    color: #606060;
}
.select_block_border span {
    font-size: 14px;
    min-width: fit-content;
}
.select_block_border {
    display: flex;
    align-items: center;
   
}
.diamond_view div {
  
    cursor: pointer;
}

.advance_filter {
    display: flex;
    align-items: center;
    cursor: pointer;
}

.advance_filter label {
    font-size: 14px;
    font-weight: 800;
    cursor: pointer;
    margin-top: -7px;
}

.reset_filter {
    display: flex;
    align-items: center;
    cursor: pointer;
    margin-left: 20px;
}

.reset_filter label {
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
}
.filter_extra_block {
    display: flex;
    align-items: center;
    margin: 2% 0;
}

.compare_box {
    width: 40%;
}
.checkbox_custom{
    font-size: 14px;
    font-weight: 600;
}
.extra_filters {
    width: 60%;
    display: flex;
    align-items: center;
    justify-content: flex-end;
}

.custom-select:focus {
    box-shadow: none;
}


@media(max-width: 1100px){
    .filterbox {
        width: 35px;
        height: 35px;
    }

    .filter_right button {
        margin-bottom: 7px;
    }
}

@media(max-width: 992px){
  /*
    .select_block_border {
        margin-left: 20px;
    }
    */
    .filter_flate {
        margin-top: 0 !important;
        align-items: center;
    }
    .diamond_options {
        margin: 4% 0 2% 0;
    }
    .filter_flate button{
        min-width: 110px;
    }
}


@media(max-width: 767px){
    .select_block_border span {
        font-weight: 600;
    }
    .select_block_border select {
        font-size: 14px;
        color: var(--green);
        font-weight: 600;
    }
    .filter_right{
        justify-content: space-between;
    }

    .reset_btn.for_mobile {
        margin-left: auto;
        margin-bottom: 15px;
    }
    .filter_flate{
        background: #f5f5f5;
        width: 100%;
        padding: 0 10px;
        margin-bottom: 15px;
    }
    .filter_flate .col-12 {
        padding: 0;
    }
    .filter_left {
        /* justify-content: center; */
        margin-top: 0;
    }
    .filter_right .select_block {
        width: auto;
        margin-left: 0px !important;
        padding-left: 0;
    }
    .filter_right .diamond_view {
        width: 25%;
        display: flex !important;
        justify-content: flex-start;
    }
    .filter_plate {
        display: flex;
        flex-wrap: wrap;
        flex-direction: column-reverse;
    }

    .filter_extra_block {
        width: 100%;
        flex-wrap: wrap;
        background: #f9f9f9;
        height: 50px;
        position: relative;
        margin: 0;
        margin-top: -53px;
        margin-bottom: 20px;
    }
    .filter_extra_block:before {
        position: absolute;
        content: "";
        height: 50px;
        background: #f9f9f9;
        width: 100px;
        left: -15px;
        z-index: -1;
    }
    .filter_extra_block:after {
        position: absolute;
        content: "";
        height: 50px;
        background: #f9f9f9;
        width: 100px;
        right: -15px;
        z-index: -1;
    }
    .extra_filters {
        width: 100%;
        justify-content: flex-start;
    }
    .checkbox_custom {
        margin-left: 0;
        width: 50%;
    }
    .diamond_view div {
        margin: 0 0 0 7px !important;
    }
}
</style>
